<template>
    <div class="container">
        <div class="row">
            <Menu class="col-lg-3"></Menu>
            <div class="col-lg-9">
                <b-card class="card">
                    <b-card-title>Настройки</b-card-title>
                    <b-card-body>
                        <b-form-group
                                id="fieldset-bonuses"
                                description="Максимальный процент стоимости мойки, который может быть покрыт бонусами."
                                label="Процент оплаты бонусами"
                                label-for="input-bonuses"
                                valid-feedback="Thank you!"
                                :invalid-feedback="form.bonuses.errorMessage"
                                :state="form.bonuses.state"
                        >
                            <b-form-input id="input-bonuses" v-model="form.bonuses.value" :state="form.bonuses.state" trim></b-form-input>
                        </b-form-group>

                        <b-form-group
                                id="fieldset-worktime"
                                label="Время работы сервиса"
                                label-for="input-worktime"
                                valid-feedback="Thank you!"
                                :invalid-feedback="form.worktime.errorMessage"
                                :state="form.worktime.state"
                        >
                            <b-form-input id="input-worktime" v-model="form.worktime.value" :state="form.worktime.state" trim></b-form-input>
                        </b-form-group>

                        <b-form-group
                                id="fieldset-vk-link"
                                description="Ссылка на группу ВКонтакте"
                                label="VK"
                                label-for="input-vk-link"
                                valid-feedback="Thank you!"
                                :invalid-feedback="form.vk.errorMessage"
                                :state="form.vk.state"
                        >
                            <b-form-input id="input-vk-link" v-model="form.vk.value" :state="form.vk.state" trim></b-form-input>
                        </b-form-group>

                        <b-form-group
                                id="fieldset-ig-link"
                                description="Ссылка на Instagram канал"
                                label="Instagram"
                                label-for="input-ig-link"
                                valid-feedback="Thank you!"
                                :invalid-feedback="form.ig.errorMessage"
                                :state="form.ig.state"
                        >
                            <b-form-input id="input-ig-link" v-model="form.ig.value" :state="form.ig.state" trim></b-form-input>
                        </b-form-group>

                        <b-form-group
                                id="fieldset-phone"
                                label="Контактный номер телефона"
                                label-for="input-phone"
                                valid-feedback="Thank you!"
                                :invalid-feedback="form.phone.errorMessage"
                                :state="form.phone.state"
                        >
                            <b-form-input id="input-phone" v-model="form.phone.value" :state="form.phone.state" trim></b-form-input>
                        </b-form-group>

                        <b-button variant="success" class="save-button" @click="submitButton">
                            <b-icon-check v-if="check"></b-icon-check>
                            Сохранить
                        </b-button>
                        <b-button variant="light" @click="updateSettings()">Отмена</b-button>
                    </b-card-body>
                </b-card>

                <b-modal ref="err-modal" size="sm" hide-footer>
                    <div class="d-block text-center">
                        Ошибка сервера!
                    </div>
                    <b-button class="mt-3" variant="danger" block @click="closeModal">ОК</b-button>
                </b-modal>
            </div>
        </div>
    </div>
</template>

<script>
    import Menu from "../../common/Menu";
    export default {
        name: "Settings",
        components: { Menu },
        data: () => ({
            form: {
                bonuses: {
                    state: null,
                    errorMessage: 'Значение должно быть от 0 до 100',
                    value: 80,
                },
                worktime: {
                    state: null,
                    errorMessage: 'Поле не может быть пустым',
                    value: '0',
                },
                vk: {
                    state: null,
                    errorMessage: 'Поле не может быть пустым',
                    value: '0',
                },
                ig: {
                    state: null,
                    errorMessage: 'Поле не может быть пустым',
                    value: '0',
                },
                phone: {
                    state: null,
                    errorMessage: 'Поле не может быть пустым',
                    value: '0',
                },
            },
            check: false,
        }),
        created() {
            this.updateSettings();
        },
        methods: {
            closeModal() {
                this.$ref['err-modal'].hide();
            },
            async fetchSettings() {
                await this.$http.get(`${process.env.VUE_APP_API_HOST}/admin/options`, {
                    headers: {
                        'Authorization': `JWT ${localStorage.getItem('jwt')}`,
                    },
                })
                        .then((result) => {
                            this.form.worktime.value = result.data.data.workTime;
                            this.form.bonuses.value = result.data.data.maxBonusesToUse;
                            this.form.vk.value = result.data.data.vkLink;
                            this.form.ig.value = result.data.data.instagramLink;
                            this.form.phone.value = result.data.data.contactPhone;
                        });
            },
            async updateSettings() {
                try {
                    await this.fetchSettings();
                    return;
                } catch (error) {
                    if (error.response) {
                        if (error.response.status === 401) {
                            await this.refreshAuth();
                        } else {
                            this.$refs['err-modal'].show();
                            return;
                        }
                    }
                }

                try {
                    await this.fetchSettings();
                } catch (error) {
                    // Show connection error
                    this.$refs['err-modal'].show();
                }
            },
            validateForm() {
                this.form.bonuses.state = null;
                this.form.worktime.state = null;
                this.form.vk.state = null;
                this.form.ig.state = null;
                this.form.phone.state = null;

                let result = true;
                if (!this.form.bonuses.value || this.form.bonuses.value <0 || this.form.bonuses.value > 100) {
                    this.form.bonuses.state = false;
                    result = false;
                }

                if (!this.form.worktime.value) {
                    this.form.worktime.state = false;
                    result = false;
                }

                if (!this.form.vk.value) {
                    this.form.vk.state = false;
                    result = false;
                }
                if (!this.form.ig.value) {
                    this.form.ig.state = false;
                    result = false;
                }
                if (!this.form.phone.value) {
                    this.form.phone.state = false;
                    result = false;
                }

                return result;
            },
            async sendOptions() {
                await this.$http.put(`${process.env.VUE_APP_API_HOST}/admin/options`, {
                    workTime: this.form.worktime.value,
                    maxBonusesToUse: this.form.bonuses.value,
                    vkLink: this.form.vk.value,
                    instagramLink: this.form.ig.value,
                    contactPhone: this.form.phone.value,
                }, {
                    headers: {
                        'Authorization': `JWT ${localStorage.getItem('jwt')}`,
                    },
                })
                        .then(() => {
                            this.check = true;
                            setTimeout(() => {
                                this.check = false;
                            }, 2000);
                        });
            },
            async submitButton() {
                if (!this.validateForm()) {
                    return;
                }

                try {
                    await this.sendOptions();
                    return;
                } catch (error) {
                    if (error.response) {
                        if (error.response.status === 401) {
                            await this.refreshAuth();
                        } else {
                            this.$refs['err-modal'].show();
                            return;
                        }
                    }
                }

                try {
                    await this.sendOptions();
                } catch (error) {
                    // Show connection error
                    this.$refs['err-modal'].show();
                }
            },
        }
    }
</script>

<style scoped>
    .save-button {
        margin-right: 10px;
    }
</style>